import React from 'react'

const Icon = ({name, size, children}) => {
  const sizeStr = size ? `fa-${size}` : null;
  const className = `fa fa-${name} ${sizeStr || ''}`
  return <span><i className={className}/> {children}</span>
}
export default Icon



/** WEBPACK FOOTER **
 ** ./app/components/Icon.jsx
 **/